import { Badge } from '@/components/Badge/Badge';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import useCellEllipsisAsCount from '@/hooks/domain/useCellEllipsisAsCount';

type Props = {
  dataList: {
    id: string;
    name: string;
  }[];
  columnWidth: number;
};

export const EllipsisCell = (props: Props) => {
  const { ref, numTagsToShow } = useCellEllipsisAsCount({
    length: props.dataList.length,
    columnWidth: props.columnWidth,
  });

  return (
    <TooltipV2
      tooltipNode={
        <div className="flex flex-col gap-1">
          {props.dataList.map((item) => (
            <span key={item.id}>{item.name}</span>
          ))}
        </div>
      }
    >
      <div className="flex items-center gap-1">
        <div className="flex items-center gap-1 flex-nowrap" ref={ref}>
          {props.dataList.slice(0, numTagsToShow).map((item) => (
            <Badge
              className={`inline-block truncate`}
              style={{
                maxWidth: Math.floor(props.columnWidth / numTagsToShow - 20),
              }}
              key={item.id}
            >
              {item.name}
            </Badge>
          ))}
        </div>
        {props.dataList.length > numTagsToShow && (
          <span className="text-xs text-gray-600">
            +{props.dataList.length - numTagsToShow}
          </span>
        )}
      </div>
    </TooltipV2>
  );
};
